export const ResponsiveDropdown = {
  mounted() {
    const lgBreakpoint = 1024;

    this.selectEl = this.el.querySelector(".responsive-dropdown-select");

    if (this.selectEl) {
      this.changeHandler = (e) => {
        const value = e.target.value;
        const optionSelect = this.selectEl.dataset.optionSelect;
        const type = this.selectEl.dataset.type;

        this.pushEventTo(this.el, optionSelect, { type: type, value: value });
      };

      this.selectEl.addEventListener("change", this.changeHandler);
    }
  },

  destroyed() {
    // Properly remove both event listeners
    if (this.selectEl && this.changeHandler) {
      this.selectEl.removeEventListener("change", this.changeHandler);
    }
  },
};
